

type CustomTabsProps = {
    tabs: string[];
    onChange?: (index: number) => void;
    activeIndex: number;
}

export const CustomTabs = ({ tabs, onChange, activeIndex }: CustomTabsProps) => {

    const handleTabClick = (index: number) => {
        onChange?.(index);
    }

    return (
        <div className="w-full border-b border-gray-200">
            <div className="flex space-x-6 overflow-y-hidden overflow-x-auto">
                {tabs.map((tab: string, index: number) => (
                    <button
                        key={index}
                        onClick={() => handleTabClick(index)}
                        className={`relative p-2 text-sm font-medium ${activeIndex === index
                            ? "text-black"
                            : "text-gray-600 hover:text-black"
                            }`}
                    >
                        {tab}
                        {activeIndex === index && (
                            <span className="absolute left-0 -bottom-[1px] h-[3px] w-full bg-primary rounded-t" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    )
}